import _ from 'lodash';
import {
    FETCH_RAINPRO_STORAGES,
    CLEAN_RAINPRO_STORAGES,
    CHANGE_RAINPRO_STORAGE,
    DELETE_RAINPRO_STORAGE,
} from './types';
import {request, __} from '../functions';

export const fetchRainproStorages = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
        callback: null,
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/rainpro/storages', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        if (options.callback !== null) {
            // Zavolame callback
            options.callback();
        }

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_RAINPRO_STORAGES, payload: data });
    });
};

export const cleanRainproStorages = () => ({ type: CLEAN_RAINPRO_STORAGES });

export const changeRainproStorage = (screen, id, data) => {
    return dispatch => request(`/rainpro/editStorage/${id}`, { data }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť sklad'));
            return;
        }

        screen.showSnackbar('success', __('Sklad bol zmenený'));

        dispatch({ type: CHANGE_RAINPRO_STORAGE, payload: { id, data } });
    });
};

export const deleteRainproStorage = (screen, id) => {
    return dispatch => request(`/rainpro/removeStorage/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Sklad sa nepodarilo zmazať'));
            return;
        }

        screen.showSnackbar('success', __('Sklad bol zmazaný'));

        dispatch({ type: DELETE_RAINPRO_STORAGE });
    });
};
